import React, { useMemo, useRef } from 'react';
import { useId } from 'react-id-generator';
import Carousel from './Carousel';
import { transformSlides } from './utils/transformSlides';
import { NavigationButton } from '../Navigation';
import { PaginationBullet } from '../Pagination';
import ReactDOMServer from 'react-dom/server';
import { cn } from '../../lib/utils';
const CarouselFullWidth = ({ className, slides, ...props }) => {
    const paginationWrapper = useRef(null);
    const [id] = useId(1, 'carousel-');
    const slideElements = useMemo(() => {
        return transformSlides(slides);
    }, [slides]);
    const pagination = {
        clickable: true,
        el: paginationWrapper.current,
        bulletClass: 'custom-bullet',
        bulletActiveClass: 'custom-bullet-active',
        renderBullet: (index, className) => ReactDOMServer.renderToString(React.createElement(PaginationBullet, { className: className, "data-active": className.includes('active'), index: index })),
    };
    return (React.createElement("div", { className: "relative bg-[#F5F7F8]" },
        React.createElement(Carousel, { id: id, slideElements: slideElements, effect: "fade", fadeEffect: { crossFade: true }, pagination: pagination, className: cn('h-full [&_.swiper-slide]:overflow-hidden', className), ...props }),
        React.createElement("div", { className: "max-w-[1335px] mx-auto px-6 md:px-12 xl:px-[60px]" },
            React.createElement("div", { className: "h-1.5 bg-gradient-bar-1" }),
            React.createElement("div", { className: "py-6 xl:pb-12 flex justify-center items-center gap-6" },
                React.createElement(NavigationButton, { className: cn(`swiper-nav-prev-${id}`, 'flex-none'), direction: "left" }),
                React.createElement("div", { className: "flex-none" },
                    React.createElement("div", { ref: paginationWrapper, className: "flex justify-center items-center gap-6" })),
                React.createElement(NavigationButton, { className: cn(`swiper-nav-next-${id}`, 'flex-none'), direction: "right" })))));
};
export default CarouselFullWidth;
